export const SORT_COLLECTIONS: string[] = [
  // 'name_ASC',
  // 'name_DESC',
  // 'popularityScore_ASC',
  'popularityScore_DESC',
  'price_ASC',
  'price_DESC',
  // 'published_ASC',
  'published_DESC',
  'sales_DESC',
  // 'sales_ASC',
  // 'updated_ASC',
  // 'updated_DESC',
]

export const DEFAULT_RESET_SEARCH_QUERY_PARAMS = [
  'sort',
  'q',
  'min',
  'max',
  'fvid',
]

export const UPSELL_FACET_VALUE_ID = '6353'
